import Enum from '../enum'

/**
 * 枚举类：订单支付方式
 * PayTypeEnum
 */
export default new Enum([
  { key: 'WECHAT', name: '微信支付', value: 1 },
  { key: 'BALANCE', name: '积分支付', value: 2 }
])
